import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postCarBrand } from "../../app/services/carBrandService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";

import Form from "react-bootstrap/Form";
import { Alert, Breadcrumb, Button, Col, Row } from "react-bootstrap";
import { CarBrand, defaultCarBrand } from "../../models/responses/carBrand";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

interface Props {}

const CarBrandAdd: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [displayError, setDisplayError] = useState(false);
  const isWaitingCarBrandPostResponse = useSelector(
    (state: RootState) => state.carBrand.isWaitingCarBrandPostResponse
  );
  const clientType = useSelector(
    (state: RootState) => state.clientType.clientType
  );
  const [carBrandData, setCarBrandData] = useState<CarBrand>(defaultCarBrand);

  const nameInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCarBrandData({ ...carBrandData, name: e.target.value });
  };

  const handleAddCarBrand = () => {
    setDisplayError(false);
    dispatch(postCarBrand(instance, account, carBrandData, onSuccess));
  };

  const onSuccess = (carBrandId: string | null) => {
    if (carBrandId === null) {
      setDisplayError(true);
      return;
    }

    setTimeout(() => {
      navigate(`../${carBrandId}`, { relative: "path" });
    }, 500);
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/car-brands">Bilmärken</Breadcrumb.Item>
        <Breadcrumb.Item active>Nytt bilmärke</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form className="w-3">
        <Row>
          <Col xs={12} md={6}>
          <Form.Group className="mb-3">
              <Form.Label>Bilmärke *</Form.Label>
              <Form.Control
                type="text"
                value={carBrandData.name}
                onInput={nameInputHandler}
              />
            </Form.Group>
          </Col>          
        </Row>

        <div className="text-end">
          <Button
            variant="primary"
            className="mb-3"
            onClick={handleAddCarBrand}
            disabled={
              !(
                carBrandData.name !== undefined &&
                carBrandData.name.length > 0 &&
                !isWaitingCarBrandPostResponse
              )
            }
          >
            Lägg till bilmärke
          </Button>
        </div>

        <Alert key="alert" variant="danger" show={displayError}>
          <p>Något gick fel, kontrollera uppgifterna och försök igen.</p>
        </Alert>
      </Form>
    </div>
  );
};

export default CarBrandAdd;
